// frontend/src/pages/Dashboard.js
// One route, two renderings. Employees see their own work; everyone who manages
// people sees the team view.
//
// Before this split, both got the team view — and since /reviews/dashboard-stats
// is require_role(admin|manager|dept_head), an employee's copy 403'd and rendered
// "Team overview · Team members: 1". That was the first screen every new employee
// saw.
import React from 'react';
import { useAuth } from '../context/AuthContext';
import TeamDashboard from './dashboard/TeamDashboard';
import MyDashboard from './dashboard/MyDashboard';

export default function Dashboard() {
  const { user } = useAuth();
  const managesPeople = ['admin', 'dept_head', 'manager'].includes(user?.role);
  return managesPeople ? <TeamDashboard /> : <MyDashboard />;
}
